export const GET_COUNTRIES = 'COUNTRIES'
export const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS'



// WEBPACK FOOTER //
// ./src/Reducers/Countries/const.js